import { render, staticRenderFns } from "./zhuanqu.vue?vue&type=template&id=781bf8a7&scoped=true"
import script from "./zhuanqu.vue?vue&type=script&lang=js"
export * from "./zhuanqu.vue?vue&type=script&lang=js"
import style0 from "./zhuanqu.vue?vue&type=style&index=0&id=781bf8a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781bf8a7",
  null
  
)

export default component.exports